/** Semantic breakpoint keys — the only per-breakpoint data is visibility (§4.2). */
export type BuilderBreakpoint = 'desktop' | 'tablet' | 'mobile';

/** One node of the builder content tree (legacy level JSON, v2 superset). */
export interface BlockNode {
    id?: string | number;
    type: string | number;
    /** Legacy data stores "0"/"1" strings — never truthiness-check directly, use isSharedBlock(). */
    useBlock?: boolean | number | string;
    value?: Record<string, unknown> | null;
    settings?: Record<string, unknown>;
    domain?: string | null;
    children?: BlockNode[];
    slot?: number;
    hidden?: boolean;
    /** Sparse visibility map — missing key = visible (§5.7). */
    visibility?: Partial<Record<BuilderBreakpoint, boolean>>;
}

/**
 * Whether the block references a Shared block (page_blocks). Mirrors the
 * v1 check: legacy content stores useBlock as "0"/"1" strings, and "0"
 * must NOT count as shared (it is truthy in JS).
 */
export function isSharedBlock(block: BlockNode): boolean {
    return Boolean(block.useBlock) && block.useBlock !== '0' && block.useBlock !== 0;
}

/**
 * Marker id of a block — must mirror RenderLevelTree::markerId() so shell
 * selection state matches the ids the bridge reads from the comments.
 */
export function markerId(block: BlockNode): string | null {
    const id = String(block.id ?? '').replace(/[^A-Za-z0-9_-]/g, '');

    return id === '' ? null : id;
}
